var _defs, _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkforceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #333;\n            }\n\n            .cls-2 {\n                fill: #3c98c9;\n            }\n\n            .cls-3 {\n                fill: #48b7da;\n            }\n        "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 20.1,
    cy: 26.3,
    rx: 15.6,
    ry: 15.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 80.1,
    cy: 19.3,
    rx: 15.6,
    ry: 15.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 43.3 91.2 c -0.1 -1.2 -0.2 -2.5 -0.2 -3.7 C 43.1 80.2 44.8 73.1 48 66.6 c -0.1 -0.2 -0.1 -0.3 -0.2 -0.5 C 39.5 50.1 22.9 40 4.8 40.1 c -1.3 0 -2.6 0 -3.9 0.2 c -0.1 1.3 -0.2 2.7 -0.2 4 C 0.8 68.5 19.2 88.8 43.3 91.2 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 43.3 91.2 C 56.6 92.6 69.8 88.2 79.7 79.3 C 89.7 70.3 95.3 57.6 95.3 44.2 c 0 -1.3 -0.1 -2.7 -0.2 -4 c -1.3 -0.1 -2.5 -0.2 -3.9 -0.2 C 73.1 40 56.5 50 48.2 66.1 c -0.1 0.2 -0.2 0.3 -0.2 0.5 C 44.8 73.1 43.1 80.2 43.1 87.5 C 43.1 88.8 43.2 90 43.3 91.2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforceLogo);
export default __webpack_public_path__ + "static/media/workforce-logo.5e95cd1448d0b88236b6357049fae0f8.svg";
export { ForwardRef as ReactComponent };